import { z } from 'zod';
import { accountOptionsRequestSchema } from '../../schema/commonRequestSchema';
export const reissueAccountBadgesBulkActionName = 'reissueAccountBadges';
export const reissueAccountBadgesBulkActionRequestSchema = z.object({
    badgeId: z.string(),
    accountBadgesToReissue: z
        .object({
        id: z.string(),
        options: accountOptionsRequestSchema.optional(),
    })
        .array(),
});
